export enum ECaseStudy {
  E_CHERHA = "e-cherha",
  E_ROAD = "e-road",
  CYBERTRACKER = "cybertracker",
  MAYOR_1551 = "1551",
  GO_GO_BAG = "go-go-bag",
  SYVI='syvi'
}
